<template>
  <v-card
    width="90%"
    class="mx-auto"
    style="margin: 15px;"
  >
    <v-card-title style="text-align: center">
      <v-flex
        xs12
        text-xs-center
      >
        <v-icon
          style="font-size: 80px;"
          :style="{
              'color': BGColor,
              'font-family': FontContent
            }"
        >
          mdi-wifi
        </v-icon>
      </v-flex>
      <v-flex
        v-if="name && name.length > 0"
        xs12
        text-xs-center
        style="font-size: 25px;"
        :style="{
            'color': ColorContent,
            'font-family': FontContent,
          }"
      >
        {{ name }}
      </v-flex>
    </v-card-title>
    <div id="temp" style="height: 30px;opacity: 0"/>
    <v-card-text style="text-align: center">
      <v-flex
        xs12
        text-xs-center
        :style="{
            'color': ColorContent,
            'font-family': FontContent
          }"
      >
        {{ $t('wifi.ssid')}}
      </v-flex>
      <v-flex
        xs12
      >
        <v-text-field
          outlined
          readonly
          :value="data.WifiSSID"
          append-icon="mdi-content-copy"
          @click:append="handleCopy(true)"
        />
      </v-flex>
      <v-flex
        xs12
        text-xs-center
        :style="{
            'color': ColorContent,
            'font-family': FontContent
          }"
      >
        {{ $t('wifi.password').toUpperCase() }}
      </v-flex>
      <v-flex
        xs12
      >
        <v-text-field
          outlined
          readonly
          :value="data.WifiPassword"
          append-icon="mdi-content-copy"
          @click:append="handleCopy(false)"
        />
      </v-flex>
      <!-- {{wifiString}} -->
      <v-img
        v-if="qrImage && qrImage.length > 0"
        :key="qrID"
        :src="qrImage"
        :lazy-src="qrImage"
        aspect-ratio="1"
        class="grey lighten-2"
        width="100%"
        height="auto"
      />
    </v-card-text>
  </v-card>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import _ from 'lodash'
  import constants from '@/constants'
  import utils from '@/services/utils'
  import QRCode from 'qrcode'
  export default {
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    data: () => ({
      qrImage: null,
      qrID: 0
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'BGColor', 'FontSizeContent', 'ColorContent']),
      name () {
        return this.data.WifiName ? utils.getTranslation (this.data.WifiName, this.locale).toUpperCase() : ''
      },
      // wifiString () {
      //   return  `WIFI:S:${this.data.WifiSSID};T:${this.data.WifiIsWep ? 'WEP' : 'WPA'};P:${this.data.WifiPassword};;`
      // },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile()
      }
    },
    watch: {
      data: {
        handler: function (newValue) {
          this.handleCreateQR()
        },
        deep: true
      },
      // 'data.WifiSSID': {
      //   handler: function (newValue) {
      //     this.handleCreateQR()
      //   },
      //   deep: true
      // },
      // 'data.WifiIsWep': {
      //   handler: function (newValue) {
      //     this.handleCreateQR()
      //   },
      //   deep: true
      // },
      // 'data.WifiPassword': {
      //   handler: function (newValue) {
      //     this.handleCreateQR()
      //   },
      //   deep: true
      // }
    },
    mounted () {
      this.handleCreateQR()
    },
    methods: {
      handleCreateQR () {
        this.qrID = _.uniqueId()
        const wifiString = `WIFI:S:${this.data.WifiSSID};T:${this.data.WifiIsWep ? 'WEP' : 'WPA'};P:${this.data.WifiPassword};;`
        QRCode.toDataURL(wifiString, {
          type: 'image/png',
          width: 344,
          color: {
            dark: this.ColorContent,  // Blue dots
            light: '#FFFFFF'
          }
        })
        .then(url => {
          this.qrImage = url
        })
        .catch(err => {
          console.error(err)
        })
      },
      handleCopy (isSSID) {
        const input = document.createElement('input');
        document.getElementById('temp').appendChild(input)
        input.value = isSSID ? this.data.WifiSSID : this.data.WifiPassword
        // 2) Select the text
          /* Select the text field */
        input.select()
        input.setSelectionRange(0, 99999) /*For mobile devices*/

        // 3) Copy text to clipboard
        const isSuccessful = document.execCommand('copy')

        // 4) Catch errors
        if (!isSuccessful) {
          console.error('Failed to copy text.')
        }
      }
    }
  }
</script>
